import { useEffect } from "react";
import { useDispatch } from "react-redux";

export const asList = <T>(value: unknown): T[] =>
  Array.isArray(value) ? value : [];

export const useLoadIfEmpty = (isEmpty: boolean, fetch: () => any) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isEmpty) {
      dispatch(fetch());
    }
  }, []);
};
